/* @ngInject */
function EmailConfirmationController ($scope, $location, $timeout, AuthService, $state, $stateParams, UserService, InitializerService, SegmentService) {
  const $rootScope = $scope.$root

  $scope.flags = {
    validConfirmationCode: false,
    validatingConfirmation: false
  }

  const api = {
    _verifyEmailConfirmation
  }
  this.getApi = () => api

  activate()

  async function activate () {
    /**
     * Verificar se há código de confirmação na URL, caso tenha, verificar se é válido.
     */
    if ($stateParams.confirmationCode) {
      $scope.flags.validatingConfirmation = true
      $timeout(() => {
        api._verifyEmailConfirmation($stateParams.confirmationCode)
      }, 1000)
      return
    }

    /**
     * Se não houver código de confirmação na URL, o código é inválido.
     */
    $scope.flags.validConfirmationCode = false

    $timeout(() => {
      $scope.flags.showSuccessToast = false
    }, 500)
  }

  /**
   * Verifica o código de confirmação de email.
   */
  function _verifyEmailConfirmation (confirmationCode) {
    UserService.verifyEmailConfirmation(confirmationCode)
      .then(({ token }) => {
        $scope.flags.validConfirmationCode = true
        $scope.flags.validatingConfirmation = false
        if (token) {
          $rootScope.oUser = null
          AuthService.setJwtToken(token)
          return InitializerService.initApplication().then(() => {
            SegmentService.track('user-login', { id: $rootScope.oUser.id, sso_enabled: false })

            const getScreen = () => {
              if ($rootScope.oUser.onboarding_status === 'COMPANY') return 'onboardingStepCompany'
              if ($rootScope.oUser.onboarding_status === 'MODULES') return 'onboardingStepModules'
              if ($rootScope.oUser.onboarding_status === 'BRANDING') return 'onboardingStepBrandingWorkflow'
              if ($rootScope.isWorkflowPlan()) return 'workflow'
              return 'home'
            }
            const screen = getScreen()

            // Aguarda um pouco antes de redirecionar para a tela inicial
            $timeout(() => {
              $state.go(screen)
            }, 10000)
          })
        }

        if (!token) {
          // Aguarda um pouco antes de redirecionar para login
          $timeout(() => {
            $state.go('login')
          }, 10000)
        }
      })
      .catch((error) => {
        console.error('Erro ao verificar código de confirmação:', error)
        $scope.flags.validConfirmationCode = false
      }).finally(() => {
        $scope.flags.validatingConfirmation = false
      })
  }
}
export { EmailConfirmationController }
